"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.base = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.info['900'], ";color:", theme.color.monochrome.white, ";position:absolute;opacity:0;visibility:hidden;max-width:", (0, _util.rem)(248), ";border-radius:", (0, _util.rem)(6), ";padding:", (0, _util.rem)(10), " ", (0, _util.rem)(14), " ", (0, _util.rem)(18), ";z-index:1100;&[data-popper-placement^='top'],&[data-popper-placement^='bottom']{text-align:center;&>.feature-callout-arrow{text-align:left;}}&[data-popper-placement^='top']>.feature-callout-arrow{bottom:", (0, _util.rem)(-4), ";}&[data-popper-placement^='bottom']>.feature-callout-arrow{top:", (0, _util.rem)(-4), ";}&[data-popper-placement^='left']>.feature-callout-arrow{right:", (0, _util.rem)(-4), ";}&[data-popper-placement^='right']>.feature-callout-arrow{left:", (0, _util.rem)(-4), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

exports.base = base;
var arrow = /*#__PURE__*/(0, _react.css)("&,&:before{position:absolute;background-color:inherit;width:", (0, _util.rem)(12), ";height:", (0, _util.rem)(12), ";}&{visibility:hidden;}&:before{visibility:visible;content:'';transform:rotate(45deg);}" + (process.env.NODE_ENV === "production" ? "" : ";label:arrow;"));
var show = process.env.NODE_ENV === "production" ? {
  name: "1gizkem",
  styles: "opacity:1;visibility:visible;transition:opacity 0.2s"
} : {
  name: "1szbxf4-show",
  styles: "opacity:1;visibility:visible;transition:opacity 0.2s;label:show;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var title = function title(theme) {
  return /*#__PURE__*/(0, _react.css)("&{color:inherit;font-weight:", theme.fontWeight.semibold, ";}.feature-callout-title-icon{font-size:", theme.fontSize.x4large, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:title;"));
};

var footer = function footer(theme) {
  return /*#__PURE__*/(0, _react.css)("button,a{color:inherit;background-color:transparent;transition:opacity,0.2s;&:hover{opacity:0.9;}}&>*{&:first-of-type{border:1px solid ", theme.color.monochrome.white, ";padding:", (0, _util.rem)(5), " ", (0, _util.rem)(12), ";border-radius:", (0, _util.rem)(4), ";font-weight:", theme.fontWeight.medium, ";&+*{margin-left:", (0, _util.rem)(18), ";}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:footer;"));
};

var styles = {
  base: base,
  arrow: arrow,
  show: show,
  title: title,
  footer: footer
};
exports.styles = styles;
//# sourceMappingURL=FeatureCallout.styles.js.map